import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pr-app-account-actions',
  templateUrl: './app-account-actions.component.html',
  styleUrls: ['./app-account-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppAccountActionsComponent {}
